import {Injectable} from "@angular/core";
import {ApiService, ValidatorService} from "@amlCore/services";
import {Observable} from "rxjs";
import {DetectTransaction, DetectTransactionSet} from "../../models/detectTransaction.model";
import {FormArray, FormBuilder, FormGroup, Validators} from "@angular/forms";

@Injectable()
export class SettingsTransactionsService {


  constructor(private api: ApiService,
              private fb: FormBuilder,
              private validationSrv: ValidatorService) {
  }

  /**
   * Получение списка сценариев выявления ПО
   */
  getSuspiciousTransactions(type: string, params: any): Observable<any> {
    return this.api.post(`/api/v1/transaction/suspicious/get/${type}`, params, 'id');
  }

  /*
   * Метод загрузки по Id сценария выявления ПО
   */
  getSuspiciousTransactionById(suspiciousId: string): Observable<any> {
    return this.api.get(`/api/v1/transaction/suspicious/${suspiciousId}`);
  }

  /**
   * Сохранение сценария выявления ПО
   */
  saveSuspiciousTransaction(body: any): Observable<any> {
    return this.api.post(`/api/v1/transaction/suspicious/update`, body);
  }
  
  /**
   * Получение списка сценариев выявления ОПОК
   */
  getDetectTransactions(params: any): Observable<any> {
    return this.api.post(`/api/v1/transaction/detect/get`, params, 'id');
  }

  /*
   * Метод загрузки по Id сценария выявления ОПОК
   */
  getDetectTransactionById(detectId: string): Observable<any> {
    return this.api.get(`/api/v1/transaction/detect/${detectId}`);
  }

  /**
   * Сохранение сценария выявления ОПОК
   */
  saveDetectTransaction(body: any): Observable<any> {
    return this.api.post(`/api/v1/transaction/detect/update`, body);
  }

  getConditionType(data: DetectTransactionSet): DetectTransactionInputType {
    if(data?.fieldType=='VARCHARLIST'){
      if(data?.fieldName?.includes('.inn'))
        return 'innList';
      return 'varcharList';
    }
    if(data?.fieldName?.includes('.account_mask'))
      return 'accountMask';
    if('t.purpose' == data.fieldName)
      return 'purpose';
    if('t.kbk' == data.fieldName)
      return 'kbk';
    if(['tp.account_cod_val', 'tr.account_cod_val'].includes(data.fieldName))
      return 'currency';
    if('t.issuer_country_kod' == data.fieldName)
      return 'countryKod';
    return 'input';
  }

  /**
   * Создание формы для сценария выявления операций
   * @param data
   */
  public createDetectTransactionForm(data: DetectTransaction){
    return this.fb.group({
      id: [data.id, Validators.required],
      active: [data.active, Validators.required],
      participantType: [data.participantType, Validators.required],
      clientType:  [data.clientType, Validators.required],
      clientTrue:  [data.clientTrue, Validators.required],
      currencyType:  [data.currencyType, Validators.required],
      settings: this.createSetFormArray(data.settings)
    });
  }

  private createSetFormArray(data: DetectTransactionSet []): FormArray {
    let setArray = this.fb.array([]);
    data.forEach(s=> {
      setArray.push(this.createSetForm(s));
    })
    return setArray;
  }

  private createSetForm(data: DetectTransactionSet): FormGroup {
    const conditionType = this.getConditionType(data);
    return this.fb.group({
      id: [data.id, Validators.required],
      description: [data.description],
      condition: [data.condition, data.condition ? Validators.required : null],
      fieldName: [data.fieldName],
      fieldType:  [data.fieldType],
      value:  [data.value, this.validationSrv.getValidation({
        isReq: this.isReqCondition(data, conditionType),
        isAccountMask: 'accountMask' == conditionType
      })],
      logic:  [data.logic],
      children: this.createSetFormArray(data.children)
    });
  }

  private isReqCondition(data: DetectTransactionSet, conditionType: DetectTransactionInputType): boolean {
    return !!data.value && !('purpose' == conditionType && '6' == data.condition);
  }
}

export type DetectTransactionInputType = 'input' | 'accountMask' | 'purpose' | 'currency' | 'countryKod' | 'varcharList'| 'kbk'| 'innList';
